import { css } from "@emotion/react";

export const messageContentStyles = css`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.4;
  letter-spacing: -0.02em;
  word-break: break-word;

  p {
    margin-top: 1rem;
    margin-bottom: 1em;
    line-height: 1.4;
  }

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.3;
    margin-top: 1.2em;
    margin-bottom: 0.4em;
    font-weight: 600;

    &:first-child {
      margin-top: 0;
    }
  }

  h1 {
    font-size: 1.35em;
  }

  h2 {
    font-size: 1.2em;
  }

  h3 {
    font-size: 1.08em;
  }

  h4 {
    font-size: 1em;
  }

  h5 {
    font-size: 0.92em;
    font-weight: 500;
  }

  h6 {
    font-size: 0.85em;
    font-weight: 500;
    color: var(--color-charcoal-60, rgba(33, 33, 33, 0.6));
  }

  ul,
  ol {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    padding-left: 1.5em;

    li {
      padding: 0;
      margin: 0.2em 0;
      line-height: 1.5;

      &:before {
        content: none;
      }
    }

    ul,
    ol {
      margin-top: 0.2em;
      margin-bottom: 0.2em;
    }
  }

  ul li {
    list-style-type: disc;
  }

  ul li li {
    list-style-type: circle;
  }

  ul li li li {
    list-style-type: square;
  }

  ol li {
    list-style-type: decimal;
  }

  strong,
  b {
    font-weight: 600;
  }

  em,
  i {
    font-style: italic;
  }

  blockquote {
    margin: 0.8em 0;
    padding: 0.1em 0 0.1em 1em;
    border-left: 3px solid rgba(33, 33, 33, 0.2);
    color: var(--color-charcoal-60, rgba(33, 33, 33, 0.6));
    font-style: italic;

    p:first-child {
      margin-top: 0;
    }

    p:last-child {
      margin-bottom: 0;
    }
  }

  hr {
    border: none;
    border-top: 1px solid rgba(33, 33, 33, 0.15);
    margin: 1em 0;
  }

  a {
    color: var(--Accessible-Blue, #3973da);
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  img {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0.8em 0;
    font-size: 0.92em;

    th,
    td {
      padding: 0.4em 0.75em;
      border: 1px solid rgba(33, 33, 33, 0.15);
      text-align: left;
    }

    th {
      font-weight: 600;
      background: rgba(33, 33, 33, 0.04);
    }

    tr:nth-child(even) td {
      background: rgba(33, 33, 33, 0.02);
    }
  }
`;
